function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import * as React from 'react';
import { ChipIcon, ChipText, ChipWrapper } from "./styles";








export const Chip = ({ className, $background, label, icon, ...rest }) => {
  return /*#__PURE__*/(
    React.createElement(ChipWrapper, _extends({ className: className, $background: $background }, rest),
    icon && /*#__PURE__*/React.createElement(ChipIcon, null, icon), /*#__PURE__*/
    React.createElement(ChipText, null, label)));


};